import { render } from "./CustomerGroups.vue?vue&type=template&id=b190fe74&scoped=true&ts=true"
import script from "./CustomerGroups.vue?vue&type=script&lang=ts"
export * from "./CustomerGroups.vue?vue&type=script&lang=ts"

import "./CustomerGroups.vue?vue&type=style&index=0&id=b190fe74&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b190fe74"]])

export default __exports__